import React from 'react';
import { Tab } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import CargomaticTab from '../../v2/navs/Tab';
import Alert from '../../ui/Alert';
import SessionStore from '../../../stores/SessionStore';
import Milestones from './edi/Milestones';
import Invoices from './edi/Invoices';
import CarrierEdiEvents from './edi/CarrierEdiEvents';

export default function EDIResender() {
  const { t } = useTranslation();

  const tabs = [
    {
      slug: 'milestones',
      name: t('MILESTONES'),
    },
    {
      slug: 'invoices',
      name: t('INVOICE', { count: 2 }),
    },
    {
      slug: 'carrier',
      name: t('CARRIER_EVENTS'),
    },
  ];

  function renderTabs() {
    return (
      <Tab.Group>
        <Tab.List>
          <div className="space-x-4">
            {tabs.map((tab) => (
              <CargomaticTab tab={tab} />
            ))}
          </div>
        </Tab.List>
        <Tab.Panels className="mt-6">
          <Tab.Panel>
            <Milestones />
          </Tab.Panel>
          <Tab.Panel>
            <Invoices />
          </Tab.Panel>
          <Tab.Panel>
            <CarrierEdiEvents />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    );
  }

  if (
    !(SessionStore.isGodAdmin() || SessionStore.hasIntegrationManagerRole())
  ) {
    return (
      <>
        <h3 key="heading" className="my-0 mb-4">
          {t('RESEND_EDI')}
        </h3>
        ,
        <Alert key="alert" type="error">
          {t('NOT_AUTHORIZED')}
        </Alert>
      </>
    );
  }
  return (
    <>
      <h3 className="my-0 mb-4">{t('RESEND_EDI')}</h3>
      {renderTabs()}
    </>
  );
}
